import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import AmountModal from "../Components/amountPerProfileModal";
import PriceCodeModal from "../Components/priceCodeModal";
import MARDrugModal from "../Components/marDrugModal";
import { Modal } from "react-responsive-modal";
import eomPriceCodeService from "../services/eom-price-code-service";
import eomPriceMatchService from "../services/eom-price-match-service";
import eomAnyZerosService from "../services/eom-any-zeroes-service";
import eomMasterService from "../services/eom-master-service";
import summitService from "../services/eom-summit-service";
import censusService from "../services/eom-census-service";
import MARDrugService from "../services/eom-mar-service";
import amountService from "../services/eom-amount-service";
import {
  updateSelectedRow,
  clearSelectedRow,
  clearData,
  getData,
  updateEomData,
} from "../state/reducers/eomSlice";
import moment from "moment";


import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import eomScreenService from "../services/eom-screen-service";
import eomAmountService from "../services/eom-amount-service";
import eomUnitcostService from "../services/eom-unitcost-service";
import eomAnyZeroesService from "../services/eom-any-zeroes-service";

const tablePropsInit = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitCensus = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "census", title: "Census" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitDS = {
  columns: [
    { key: "drug_name", title: "Drug name" },
    { key: "gpi", title: "GPI" },
    { key: "ndc", title: "NDC" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitCF = {
  columns: [
    { key: "drug_name", title: "Drug name" },
    { key: "gpi", title: "GPI" },
    { key: "formulary", title: "Formulary" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitMAR = {
  columns: [
    { key: "drug_name", title: "Drug name" },
    { key: "description", title: "Description" },
    { key: "ndc", title: "NDC" },
    { key: "cost", title: "Cost" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitAmount = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "amt_due", title: "Amount due" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitPC = {
  columns: [
    { key: "payor", title: "Payor" },
    // { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "price_code", title: "Price code" },
    { key: "acq_min", title: "ACQ from" },
    { key: "acq_max", title: "ACQ to" },
    { key: "factor", title: "Factor" },
    { key: "fees", title: "Fees" },
    { key: "actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitPM = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "drug_name", title: "Drug name" },
    { key: "qty", title: "Quantity" },
    { key: "price", title: "Price" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitSummit = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "rxf_number", title: "Reference Number" },
    { key: "seq_num", title: "Sequence Number" },
    { key: "doctor_name", title: "Doctor Name" },
    { key: "doctor_grouping", title: "Doctor grouping" },
    { key: "actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const tablePropsInitAZ = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "unique", title: "Charge code" },
    { key: "rxf_number", title: "RXF Number " },
    { key: "drug_name", title: "Drug Name" },
    { key: "qty", title: "Quantity" },
    { key: "amt_due", title: "Amount due" },
    { key: "acq", title: "Aquisition" },
    { key: "type11", title: "Type", style: { display: "none" } },
    { key: "price_code", title: "Price Code" },
    { key: "disease_state", title: "Disease state" },
    { key: "type", title: "Type" },
    { key: "actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const tablePropsInitUC = {
  columns: [
    { key: "ndc", title: "NDC" },
    { key: "drug_name", title: "Drug Name" },
    { key: "old_price", title: "Last month price" },
    { key: "flag_1", title: "Price 1", style: { width: "100px" } },
    { key: "flag_2", title: "Price 2", style: { width: "100px" } },
    { key: "flag_3", title: "Price 3", style: { width: "100px" } },

    { key: "flag_4", title: "Price 4", style: { width: "100px" } },
    { key: "flag_233", title: "Price 2", style: { display: "none" } },

    { key: "flag_5", title: "Price 5", style: { width: "100px" } },
    { key: "flag_6", title: "Price 6", style: { width: "100px" } },
    { key: "flag_7", title: "Price 7", style: { width: "100px" } },
    { key: "flag_8", title: "Price 8", style: { width: "100px" } },
    { key: "flag_9", title: "Price 9", style: { width: "100px" } },
    { key: "flag_10", title: "Price 10", style: { width: "100px" } },
    { key: "other_amt", title: "Other amount", style: { width: "150px" } },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "ndc",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const EOM = () => {
  let { fyear, fmonth, fscreen } = useSelector(getData);

  const [loading, setLoading] = useState(false);
  const [showScreen, setShowScreen] = useState(false);
  const [screen, setScreen] = useState();
  const dispatch1 = useDispatch();

  const [selectedScreen, setSelectedScreen] = useState(fscreen);
  const totalMonthsList = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.map((i, index) => (
      <option value={index + 1} key={i}>
        {i}
      </option>
    ));
  };
  const totalYears = () => {
    const years = [];
    const dateStart = moment().subtract(1, "y");
    const dateEnd = moment().add(1, "y");
    while (dateEnd.diff(dateStart, "years") >= 0) {
      years.push(dateStart.format("YYYY"));
      dateStart.add(1, "year");
    }
    return years;
  };
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };

  const totalScreenList = () => {
    return screenList.map((item, index) => (
      <option value={item.id} key={item.id} disabled={item.disable}>
        {item.value}
      </option>
    ));
  };
  useEffect(() => {
    if (fyear && fmonth) {
      setYear(fyear);
      setMonth(fmonth);
      updateWithData();
    }
  }, []);
  const updateWithData = async () => {
    try {
      await getScreens(fmonth, fyear);
      setSelectedScreen(fscreen);
      setShowScreen(true);
      setScreen(fscreen);
      handleAllDownload();
      await handleGo(fscreen, fmonth, fyear);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting drug. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const [parentList, setParentList] = useState([]);
  const [parent, setParent] = useState("SHP");
  const [groupList, setGroupList] = useState([]);
  const [group, setGroup] = useState("JATX");
  const [chargeCodeList, setChargeCodeList] = useState([]);
  const [chargeCode, setChargeCode] = useState("JATX-COU");
  useEffect(() => {
    getPayors();
    getGroups();
  }, []);

  useEffect(() => {
    if (parent) getGroups(parent);
  }, [parent]);
  useEffect(() => {
    if (group) getChargeCodes(parent, group);
  }, [group]);
  const getPayors = async () => {
    try {
      let resp = await eomMasterService.getPayors();
      if (resp) {
        setParentList(resp);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting payors. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const getGroups = async (parent) => {
    let totalGroupList = [];
    try {
      totalGroupList = await eomMasterService.getGroupCodes(parent);
      setGroupList(totalGroupList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting groups. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getChargeCodes = async (parent, group) => {
    try {
      var codes = await eomMasterService.getUniqueCodes(parent, group);
      setChargeCodeList(codes);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting charge codes. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const [amtDue, setAmtDue] = useState("");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(false);
  const [disableSubmit, setDisbleSubmit] = useState(false);

  const onSubmit = async () => {
    try {
      if (
        !parent.length ||
        !group.length ||
        !chargeCode.length ||
        !amtDue ||
        amtDue === "0"
      ) {
        setError(true);
        return;
      }
      setLoading(true);
      var data = {
        payor: parent,
        group: group,
        unique: chargeCode,
        amt_due: amtDue,
        year,
        month,
      };
      await eomScreenService.createIndigentCheck(data);
      handleDone(screen);
      setParent("SHP");
      setGroup("JATX");
      setChargeCode("JATX-COU");
      setAmtDue("");
      setError(false);
      setLoading(false);
      const { hide } = cogoToast.success("Data submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const onSHPSubmit = async () => {
    try {
      if (!amount || amount === "0") {
        setError(true);
        return;
      }
      setLoading(true);
      var data = {
        amt_due: Number(amount),
        year,
        month,
      };
      await eomScreenService.createSHP(data);
      setAmount("");
      setError(false);
      setDisbleSubmit(true);
      setLoading(false);

      const { hide } = cogoToast.success("Data submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [argumnts, setArgumnts] = useState([]);
  const [modifiedItems, setModifiedItems] = useState([]);
  const CustomCellNewCheckbox = ({ rowData }) => {
    let name = "price_" + rowData.column.key.split("_")[1];
    return (
      <div>
        {rowData.rowData[name] !== 0 && (
          <div>
            <input
              type="checkbox"
              checked={rowData.rowData[rowData.column.key]}
              onChange={(e) => {
                let items = modifiedItems;
                let data = rowData.rowData;
                if (!items.includes(data.ndc)) {
                  items.push(data.ndc);
                }

                setModifiedItems(items);

                let gridIndex = gridData.findIndex(
                  (item) => item.ndc === rowData.rowData.ndc
                );
                var gData = gridData;
                gData[gridIndex][rowData.column.key] = e.target.checked;
                gData[gridIndex]["other_amt_req"] = false;
                if (
                  gData[gridIndex]["other_amt"] === null ||
                  gData[gridIndex]["other_amt"] === ""
                ) {
                  for (const [key, value] of Object.entries(gData[gridIndex])) {
                    if (key.startsWith("price") && value !== 0) {
                      let index = key.split("_")[1];
                      if (gData[gridIndex]["flag_" + index] !== true) {
                        gData[gridIndex]["other_amt_req"] = true;
                      }
                    }
                  }
                }

                setGridData(gData);
                dispatchUnitCost(updateData(gData));
              }}
            />
            <label className="ml-2 relative bottom-0.5">
              {rowData.rowData[name]}
            </label>
          </div>
        )}
      </div>
    );
  };

  const handleUnitCostSubmit = async () => {
    try {
      setLoading(true);
      let payload = [];
      let items = [];
      items = gridData.filter((item) => modifiedItems.includes(item.ndc));
      for (var i = 0; i < items?.length; i++) {
        let needed = true;
        for (const [key, value] of Object.entries(items[i])) {
          if (key.startsWith("price") && value !== 0) {
            let index = key.split("_")[1];
            if (items[i]["flag_" + index] !== null)
              items[i]["flag_" + index] = items[i]["flag_" + index]
                ? "T"
                : null;
            if (
              (items[i]["other_amt"] === null || items[i]["other_amt"] === 0) &&
              (items[i]["flag_" + index] === false ||
                items[i]["flag_" + index] === null)
            ) {
              needed = false;
            }
          }
        }

        if (
          needed ||
          (items[i]["other_amt"] !== null && items[i]["other_amt"] !== "")
        ) {
          payload.push(items[i]);
        }
      }

      await eomUnitcostService.submitMultiData(payload);
      let resp = await eomScreenService.getUnitCostErrors(year, month);
      setGridData(resp);
      dispatchUnitCost(updateData(resp));

      setLoading(false);
      setModifiedItems([]);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const CustomCellOther = ({ rowData }) => {
    return (
      <div>
        <input
          id="other_amt"
          name="other_amt"
          type="number"
          defaultValue={rowData.other_amt}
          onBlur={(e) => {
            let items = modifiedItems;
            let data = rowData;
            if (!items.includes(data.ndc)) {
              items.push(data.ndc);
            }

            setModifiedItems(items);

            let gridIndex = gridData.findIndex(
              (item) => item.ndc === rowData.ndc
            );
            var gData = gridData;
            if (e.target.value.trim().length) {
              gData[gridIndex]["other_amt_req"] = false;
            } else {
              gData[gridIndex]["other_amt_req"] = true;
            }

            gData[gridIndex]["other_amt"] = e.target.value;

            setGridData(gData);
            dispatchUnitCost(updateData(gData));
          }}
          className={` ${rowData.other_amt_req ? "border-red-400" : ""
            }  text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full`}
        />
        {rowData?.other_amt_req && <span>Required</span>}
      </div>
    );
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div
        className="action_btns"
        onClick={() => {
          dispatch1(updateSelectedRow(rowData));
          dispatch1(
            updateEomData({
              year: year,
              month: month,
              screen: screen,
            })
          );
        }}
      >
        <span className="inline-block mr-3 cursor-pointer">
          <Link to={"create-facility"}>
            <img src="/img/addIcon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
      </div>
    );
  };

  const CustomCellDS = ({ rowData }) => {
    return (
      <div
        className="action_btns"
        onClick={() => {
          dispatch1(updateSelectedRow(rowData));
          dispatch1(
            updateEomData({
              year: year,
              month: month,
              screen: screen,
            })
          );
        }}
      >
        <span className="inline-block mr-3 cursor-pointer">
          <Link to={"create-drug"}>
            <img src="/img/addIcon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
      </div>
    );
  };
  const CustomCellAmount = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/edit_icon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setOpenPopUp(true);
              setArgumnts(rowData);
            }}
            alt="Edit"
            title="Edit"
          />
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setSelectedId(rowData?.id);
              setDeleteOpen(true);
            }}
            alt="delete"
            title="Delete"
          />
        </span>
      </div>
    );
  };
  const [selectedId, setSelectedId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const onDeleteCloseModal = () => {
    setDeleteOpen(false);
    setSelectedId("");
  };
  const CustomCellMAR = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/edit_icon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setMAROpenPopUp(true);
              setArgumnts(rowData);
            }}
            alt="Edit"
            title="Edit"
          />
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setSelectedId(rowData?.id);
              setDeleteOpen(true);
            }}
            alt="delete"
            title="Delete"
          />
        </span>
      </div>
    );
  };
  const CustomCellSummit = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/edit_icon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setSummitOpenPopUp(true);
              setArgumnts(rowData);
            }}
            alt="Edit"
            title="Edit"
          />
        </span>
      </div>
    );
  };

  const CustomCellAZ = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span
          className="inline-block mr-3 cursor-pointer"
          onClick={() => {
            dispatch1(updateSelectedRow(rowData));
            dispatch1(
              updateEomData({
                year: year,
                month: month,
                screen: screen,
              })
            );
          }}
        >
          <Link to={"create-anyZeros"}>
            <img src="/img/addIcon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            alt="delete"
            title="Delete"
            onClick={() => {
              setSelectedId(rowData?.eom_id);
              setDeleteOpen(true);
            }}
          />
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/check.png"
            className="m-auto w-4 h-4"
            alt="Done"
            title="Done"
            onClick={() => {
              onSubmitAZ(rowData);
            }}
          />
        </span>
      </div>
    );
  };

  const onSubmitAZ = async (rowData) => {
    try {
      setLoading(true);
      var data = {};
      data["price_code"] = rowData?.price_code;
      data["qty"] = rowData?.qty;
      data["acq"] = 0;
      data["amt_due"] = 0;

      data["eom_id"] = rowData?.eom_id;
      data["group"] = rowData?.group;
      data["payor"] = rowData?.payor;
      data["unique"] = rowData?.unique;
      data["year"] = rowData?.year;
      data["month"] = rowData?.month;
      data["type"] = rowData?.type;
      data["rxf_number"] = rowData?.rxf_number;
      data["seq_num"] = rowData?.seq_num;
      data["drg_name"] = rowData?.drg_name;

      await eomAnyZerosService.createData(data);
      let resp = await eomScreenService.getAZErrors(year, month);
      resp?.sort((a, b) => (a.rxf_number > b.rxf_number) ? 1 : ((b.rxf_number > a.rxf_number) ? -1 : 0));
      dispatchAZ(updateData(resp));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const CustomCellPC = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/addIcon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setOpenPCPopUp(true);
              setArgumnts(rowData);
            }}
            alt="Add"
            title="Add"
          />
        </span>
      </div>
    );
  };
  const CustomCellPM = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span
          className="inline-block mr-3 cursor-pointer"
          onClick={() =>
            dispatch1(
              updateEomData({
                year: year,
                month: month,
                screen: screen,
              })
            )
          }
        >
          <Link to={`edit-priceMatch/${rowData.id}`}>
            <img src="/img/edit_icon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            alt="delete"
            title="Delete"
            onClick={() => {
              setSelectedId(rowData?.id);
              setDeleteOpen(true);
            }}
          />
        </span>
      </div>
    );
  };
  const CustomCellCensus = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/addIcon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              setCensusOpenPopUp(true);
              setArgumnts(rowData);
              setCensus(rowData?.census);
            }}
            alt="Edit"
            title="Edit"
          />
        </span>
      </div>
    );
  };
  const CustomCellCF = ({ rowData }) => {
    return (
      <div
        className="action_btns"
        onClick={() => {
          dispatch1(updateSelectedRow(rowData));
          dispatch1(
            updateEomData({
              year: year,
              month: month,
              screen: screen,
            })
          );
        }}
      >
        <span className="inline-block mr-3 cursor-pointer">
          <Link to={"create-formula"}>
            <img src="/img/addIcon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
      </div>
    );
  };
  const deleteProfile = async (id) => {
    try {
      await eomAmountService.deleteProfile(id);
      let resp = await eomAmountService.getAmountPerProfile();
      dispatchAmount(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const deleteAZ = async (id) => {
    try {
      setLoading(true);
      await eomAnyZeroesService.deleteEOMData(id);
      let resp = await eomScreenService.getAZErrors(year, month);
      resp?.sort((a, b) => (a.rxf_number > b.rxf_number) ? 1 : ((b.rxf_number > a.rxf_number) ? -1 : 0))
      dispatchAZ(updateData(resp));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error deleting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const deleteMARDrug = async (id) => {
    try {
      await MARDrugService.deleteMARDrug(id);
      let resp = await MARDrugService.getMARDrugs();
      dispatchMAR(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const deleteCensus = async (id) => {
    try {
      await censusService.deleteData(id);
      let resp = await eomScreenService.getCensusErrors();
      dispatchMAR(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const [month, setMonth] = useState(fmonth);
  const [year, setYear] = useState(moment().format("YYYY"));
  const [screenList, setScreenList] = useState([]);
  const [screen1Val, setScreen1Val] = useState();
  const [gridData, setGridData] = useState([]);
  const [id, setId] = useState();

  const sObj = {
    screen_1: "Import Data",
    screen_2: "Validate Facilities",
    screen_3: "Amount due per profile",
    screen_4: "MAR",
    screen_5: "Census",
    screen_6: "Disease States",
    screen_7: "Corecivic formulary",
    screen_8: "Unit price",
    screen_9: "Price codes",
    screen_10: "Summit",
    screen_11: "Price match",
    screen_12: "Intermediate step",
    screen_13: "Any Zeros",
    screen_14: "SHP TOP 10",
    screen_15: "Indigent Check",
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await eomScreenService.getMasterErrors(year, month);
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };

  const [tablePropsAZ, changeTablePropsAZ] = useState(tablePropsInitAZ);
  const dispatchAZ = async (action) => {
    changeTablePropsAZ((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = gridData;
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchAZ(updateData(resp));
    }
  };
  const [tablePropsSummit, changeTablePropsSummit] =
    useState(tablePropsInitSummit);
  const dispatchSummit = async (action) => {
    changeTablePropsSummit((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = gridData;
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchSummit(updateData(resp));
    }
  };
  const [tablePropsUC, changeTablePropsUC] = useState(tablePropsInitUC);
  const dispatchUnitCost = async (action) => {
    changeTablePropsUC((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = gridData;
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchUnitCost(updateData(resp));
    }
  };
  const [tablePropsPC, changeTablePropsPC] = useState(tablePropsInitPC);
  const dispatchPriceCode = async (action) => {
    changeTablePropsPC((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = gridData;
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchPriceCode(updateData(resp));
    }
  };

  const [tablePropsPM, changeTablePropsPM] = useState(tablePropsInitPM);
  const dispatchPriceMatch = async (action) => {
    changeTablePropsPM((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = gridData;
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchPriceMatch(updateData(resp));
    }
  };

  const [tablePropsCensus, changeTablePropsCensus] =
    useState(tablePropsInitCensus);
  const dispatchCensus = async (action) => {
    changeTablePropsCensus((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await eomScreenService.getCensusErrors(year, month);
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchCensus(updateData(resp));
    }
  };

  const [tablePropsDS, changeTablePropsDS] = useState(tablePropsInitDS);
  const dispatchDS = async (action) => {
    changeTablePropsDS((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await eomScreenService.getDSErrors(year, month);
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchDS(updateData(resp));
    }
  };
  const [tablePropsCF, changeTablePropsCF] = useState(tablePropsInitCF);
  const dispatchCF = async (action) => {
    changeTablePropsCF((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await eomScreenService.getCFErrors(year, month);
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchCF(updateData(resp));
    }
  };
  const [tablePropsAmount, changeTablePropsAmount] =
    useState(tablePropsInitAmount);
  const dispatchAmount = async (action) => {
    changeTablePropsAmount((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await amountService.getAmountPerProfile();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchAmount(updateData(resp));
    }
  };
  const [tablePropsMAR, changeTablePropsMAR] = useState(tablePropsInitMAR);
  const dispatchMAR = async (action) => {
    changeTablePropsMAR((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await MARDrugService.getMARDrugs();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatchMAR(updateData(resp));
    }
  };
  const handleUpdateCensus = async (census, id) => {
    try {
      argumnts["census"] = census;
      await censusService.createData(argumnts);
      setCensusOpenPopUp(false);
      setArgumnts([]);
      const resp = await eomScreenService.getCensusErrors(year, month);
      setGridData(resp);
      setCensus("");
      dispatchCensus(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error updating status. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleUpdateSummit = async (doctorGrp, id) => {
    try {
      let data = {
        doctor_grouping: doctorGrp,
        id: id,
      };
      await summitService.updateData(data);
      setSummitOpenPopUp(false);
      setArgumnts([]);
      const resp = await summitService.getSummitData(year, month);
      setGridData(resp);
      setDoctorGrp("");
      dispatchSummit(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error updating status. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleDone = async (screen) => {
    try {
      setLoading(true);
      let obj = {};
      obj["id"] = id;
      obj[screen] = "T";
      if (screen === "screen_5") {
        obj["screen_4"] = "T";
      }
      await eomScreenService.updateScreen(id, obj);
      setLoading(false);
      getScreens(month, year);
      dispatch1(clearSelectedRow());
      dispatch1(clearData());
      setScreen("");
      setSelectedScreen("");
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error updating status. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleClear = async () => {
    try {
      setLoading(true);

      await eomScreenService.clearScreen(id);
      setLoading(false);
      getScreens(month, year);
      dispatch1(clearSelectedRow());
      dispatch1(clearData());
      setScreen("");
      setSelectedScreen("");
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error updating status. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleGo = async (screen, month, year) => {
    try {
      if (screen === "screen_1") {
        await eomScreenService.importData({ year, month });
        setSelectedScreen(screen);
      } else if (screen === "screen_2") {
        setLoading(true);
        let resp = await eomScreenService.getMasterErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatch(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_3") {
        const resp = await amountService.getAmountPerProfile();
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchAmount(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_5") {
        const resp = await eomScreenService.getCensusErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchCensus(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_7") {
        const resp = await eomScreenService.getCFErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchCF(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_8") {
        setLoading(true);
        setModifiedItems([]);
        const resp = await eomScreenService.getUnitCostErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchUnitCost(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_9") {
        setLoading(true);
        const resp = await eomScreenService.getPCErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort((a, b) => (a.payor > b.payor) ? 1 : ((b.payor > a.payor) ? -1 : 0))
        dispatchPriceCode(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_10") {
        setLoading(true);
        const resp = await summitService.getSummitData(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchSummit(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_11") {
        setLoading(true);
        const resp = await eomPriceMatchService.getPriceMatchData();
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchPriceMatch(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_13") {
        setLoading(true);
        const resp = await eomScreenService.getAZErrors(year, month);
        resp?.sort((a, b) => (a.rxf_number > b.rxf_number) ? 1 : ((b.rxf_number > a.rxf_number) ? -1 : 0))
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchAZ(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_15") {
        setSelectedScreen(screen);
      } else if (screen === "screen_6") {
        setLoading(true);
        let resp = await eomScreenService.getDSErrors(year, month);
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchDS(updateData(resp));
        setLoading(false);
      } else if (screen === "screen_4") {
        const resp = await MARDrugService.getMARDrugs();
        setGridData(resp);
        setSelectedScreen(screen);
        resp?.sort(
          (d1, d2) =>
            new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
        );
        dispatchMAR(updateData(resp));
        setLoading(false);
      } else {
        setSelectedScreen(screen);
      }
      setError(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getScreens = async (month, year) => {
    try {
      if (!month || !year) {
        const { hide } = cogoToast.error("Please select month and year", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        return;
      }
      setLoading(true);
      dispatch1(clearData);
      dispatch1(clearSelectedRow);
      const resp = await eomScreenService.getScreens(month, year);
      setId(resp.id);
      var list = [];
      var index = 1;
      for (const [key, value] of Object.entries(resp)) {
        if (key.startsWith("screen")) {
          if (key === "screen_1") setScreen1Val(value);
          list.push({
            id: key,
            value: sObj[key] || "Screen " + index,
            disable: value === "T",
          });
          index++;
        }
      }
      setScreenList(list);

      setShowScreen(true);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handleDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadMasterData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handleMARDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await MARDrugService.downloadDocument();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const handlePCDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadPCData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handlePMDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomPriceMatchService.downloadDocument();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handleAZDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadAZData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const deletePriceMatch = async (id) => {
    try {
      await eomPriceMatchService.deleteData(id);
      let resp = await eomPriceMatchService.getPriceMatchData();
      dispatchPriceMatch(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting price. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const deletePriceCode = async (id) => {
    try {
      await eomPriceCodeService.deleteData(id);
      let resp = await eomPriceCodeService.getPriceCodesData();
      dispatchPriceCode(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting price code. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handleCensusDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadCensusData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const handleDSDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadDSData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const handleUCDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadUCData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const handleCFDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomScreenService.downloadCFData(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const handleDeleteDownload = async ({ is_shp, resp }) => {
    try {
      await eomScreenService.deleteDownloadData(resp?.id);
      is_shp ? setShowSHPDownload(false) : setShowEOMDownload(false);
      is_shp ? setShowSHPGenerateDownload(true) : setShowEOMGenerateDownload(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        `Error deleting ${is_shp ? "SHP" : "EOM"} data. Please try after sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const handlePostDownload = async ({ is_shp }) => {
    try {
      const { hide } = cogoToast.info(
        `${is_shp ? "SHP" : "EOM"} file is being generated. Please wait for sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      let params = {
        year,
        month,
        is_shp: is_shp ? "T" : "F"
      };
      await eomScreenService.postDownloadData(params);
      is_shp ? setShowSHPGenerateDownload(false) : setShowEOMGenerateDownload(false);
      is_shp ? setShowSHPProgressDownload(true) : setShowEOMProgressDownload(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating EOM data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const handleMissouriAndIndianaDownload = async () => {
    try {
      const { hide } = cogoToast.info(
        `Missouri and Indiana file is being generated. Please wait for sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      let params = {
        year,
        month,
        is_cen: "M"
      };
      await eomScreenService.postDownloadData(params);
      setShowMissouriProgressDownload(true);
      setShowMissouriGenerateDownload(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating Missouri and Indiana data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const handleMissouriAndIndianaDeleteDownload = async (resp) => {
    try {
      await eomScreenService.deleteDownloadData(resp?.id);
      setShowMissouriDownload(false);
      setShowMissouriGenerateDownload(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        `Error deleting Centurion data. Please try after sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const handleKansasAndIdahoDownload = async () => {
    try {
      const { hide } = cogoToast.info(
        `Kansas And Idaho EOM file is being generated. Please wait for sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      let params = {
        year,
        month,
        is_cen: "K"
      };
      await eomScreenService.postDownloadData(params);
      setShowKansasProgressDownload(true);
      setShowKansasGenerateDownload(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error generating Kansas And Idaho data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const handleKansasAndIdahoDeleteDownload = async (resp) => {
    try {
      await eomScreenService.deleteDownloadData(resp?.id);
      setShowKansasDownload(false);
      setShowKansasGenerateDownload(true);
    } catch (e) {
      const { hide } = cogoToast.error(
        `Error deleting Kansas And Idaho data. Please try after sometime.`,
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const [showEOMGenerateDownload, setShowEOMGenerateDownload] = useState(false);
  const [showEOMDownload, setShowEOMDownload] = useState(false);
  const [showEOMProgressDownload, setShowEOMProgressDownload] = useState(false);
  const [EOMData, setEOMData] = useState({});

  const [showSHPGenerateDownload, setShowSHPGenerateDownload] = useState(false);
  const [showSHPDownload, setShowSHPDownload] = useState(false);
  const [showSHPProgressDownload, setShowSHPProgressDownload] = useState(false);
  const [SHPData, setSHPData] = useState({});

  const [showMissouriGenerateDownload, setShowMissouriGenerateDownload] = useState(false);
  const [showMissouriDownload, setShowMissouriDownload] = useState(false);
  const [showMissouriProgressDownload, setShowMissouriProgressDownload] = useState(false);
  const [missouriData, setMissouriData] = useState({});

  const [showKansasGenerateDownload, setShowKansasGenerateDownload] = useState(false);
  const [showKansasDownload, setShowKansasDownload] = useState(false);
  const [showKansasProgressDownload, setShowKansasProgressDownload] = useState(false);
  const [kansasData, setKansasData] = useState({});

  const handleFileDownload = async (file) => {
    try {
      const downloadLink = document.createElement("a");
      downloadLink.href = file?.file_name;
      downloadLink.download = file?.file_name.split("/")[1];
      downloadLink.click();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }

  const handleEOMDataDownload = async (resp) => {
    if (resp.is_ready === "T") {
      setShowEOMDownload(true);
      setShowEOMGenerateDownload(false);
      setShowEOMProgressDownload(false);
    } else if (resp.is_ready === "F") {
      setShowEOMProgressDownload(true);
      setShowEOMDownload(false);
      setShowEOMGenerateDownload(false);
    }
    setEOMData(resp);
  }

  const handleSHPDataDownload = async (resp) => {
    if (resp.is_ready === "T") {
      setShowSHPDownload(true);
      setShowSHPGenerateDownload(false);
      setShowSHPProgressDownload(false);
    } else if (resp.is_ready === "F") {
      setShowSHPProgressDownload(true);
      setShowSHPDownload(false);
      setShowSHPGenerateDownload(false);
    }
    setSHPData(resp);
  }

  const handleMissouriAndKansasEOMDataDownload = async (resp) => {

    if (resp.is_cen === "M") {
      if (resp.is_ready === "T") {
        setShowMissouriDownload(true);
        setShowMissouriGenerateDownload(false);
        setShowMissouriProgressDownload(false);
      } else if (resp.is_ready === "F") {
        setShowMissouriProgressDownload(true);
        setShowMissouriDownload(false);
        setShowMissouriGenerateDownload(false);
      }

      setMissouriData(resp);
    }

    if (resp.is_cen === "K") {
      if (resp.is_ready === "T") {
        setShowKansasDownload(true);
        setShowKansasGenerateDownload(false);
        setShowKansasProgressDownload(false);
      } else if (resp.is_ready === "F") {
        setShowKansasProgressDownload(true);
        setShowKansasDownload(false);
        setShowKansasProgressDownload(false);
      }

      setKansasData(resp);
    }
  }

  const resetButtonState = () => {
    setShowScreen(false);

    setShowEOMGenerateDownload(false);
    setShowEOMDownload(false);
    setShowEOMProgressDownload(false);

    setShowSHPGenerateDownload(false);
    setShowSHPDownload(false);
    setShowSHPProgressDownload(false);

    setShowMissouriDownload(false);
    setShowMissouriGenerateDownload(false);
    setShowMissouriProgressDownload(false);

    setShowKansasDownload(false);
    setShowKansasGenerateDownload(false);
    setShowKansasProgressDownload(false);
  }

  const handleAllDownload = async () => {
    try {
      await resetButtonState();
      let resp = await eomScreenService.downloadData(year, month);
      if (resp?.length) {
        const hasGenerateEOMDATA = resp.some(item => item.is_shp === "F");
        const hasGenerateMissouriEOMDATA = resp.some(item => item.is_cen === 'M');
        const hasGenerateKansasEOMDATA = resp.some(item => item.is_cen === 'K');
        const hasGenerateSHPEOMDATA = resp.some(item => item.is_shp === "T");

        if (!hasGenerateEOMDATA) {
          setShowEOMGenerateDownload(true);
        }
        if (!hasGenerateSHPEOMDATA) {
          setShowSHPGenerateDownload(true);
        }

        if (!hasGenerateMissouriEOMDATA) {
          setShowMissouriGenerateDownload(true);
        }

        if (!hasGenerateKansasEOMDATA) {
          setShowKansasGenerateDownload(true);
        }

        resp.forEach(item => {
          if (item.is_shp === "F") {
            handleEOMDataDownload(item);
          }
          else if (item.is_shp === "T") {
            handleSHPDataDownload(item);
          }
          if (item.is_cen === "M" || item.is_cen === "K") {
            handleMissouriAndKansasEOMDataDownload(item);
          }
        });
      } else {
        setShowEOMGenerateDownload(true);
        setShowEOMDownload(false);
        setShowEOMProgressDownload(false);

        setShowSHPGenerateDownload(true);
        setShowSHPDownload(false);
        setShowSHPProgressDownload(false);

        setShowMissouriGenerateDownload(true);
        setShowMissouriDownload(false);
        setShowMissouriProgressDownload(false);

        setShowKansasGenerateDownload(true);
        setShowKansasDownload(false);
        setShowKansasProgressDownload(false);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    totalScreenList();
  }, [screenList]);

  const [openPopUp, setOpenPopUp] = useState(false);
  const onCloseRepModal = async () => {
    setOpenPopUp(false);
    setArgumnts({});
    const resp = await amountService.getAmountPerProfile();
    setGridData(resp);
    dispatchAmount(updateData(resp));
  };

  const [openPCPopUp, setOpenPCPopUp] = useState(false);
  const onClosePCModal = async () => {
    setOpenPCPopUp(false);
    setArgumnts({});
    const resp = await eomScreenService.getPCErrors(year, month);
    resp?.sort((a, b) => (a.payor > b.payor) ? 1 : ((b.payor > a.payor) ? -1 : 0))
    setGridData(resp);
    dispatchPriceCode(updateData(resp));
  };

  const [openMARPopUp, setMAROpenPopUp] = useState(false);
  const onCloseMARModal = async () => {
    setMAROpenPopUp(false);
    setArgumnts({});
    const resp = await MARDrugService.getMARDrugs();
    setGridData(resp);
    dispatchMAR(updateData(resp));
  };

  const [openCensusPopUp, setCensusOpenPopUp] = useState(false);
  const onCloseCensusModal = async () => {
    setCensusOpenPopUp(false);
    setArgumnts({});
    const resp = await eomScreenService.getCensusErrors(year, month);
    setGridData(resp);
    setCensus("");
    dispatchCensus(updateData(resp));
  };
  const [doctorGrp, setDoctorGrp] = useState("");
  const [openSummitPopUp, setSummitOpenPopUp] = useState(false);
  const onCloseSummitModal = async () => {
    setSummitOpenPopUp(false);
    setArgumnts({});
    const resp = await summitService.getSummitData(year, month);
    setGridData(resp);
    setDoctorGrp("");
    dispatchSummit(updateData(resp));
  };
  const [census, setCensus] = useState("");
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to delete?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                if (selectedScreen === "screen_4") {
                  deleteMARDrug(selectedId);
                } else if (selectedScreen === "screen_5") {
                  deleteCensus(selectedId);
                } else if (selectedScreen === "screen_3") {
                  deleteProfile(selectedId);
                } else if (selectedScreen === "screen_9") {
                  deletePriceCode(selectedId);
                } else if (selectedScreen === "screen_11") {
                  deletePriceMatch(selectedId);
                } else if (selectedScreen === "screen_13") {
                  deleteAZ(selectedId);
                }
                setDeleteOpen(false);
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setDeleteOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <Modal open={openCensusPopUp} onClose={onCloseCensusModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Create
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="p-2 text-xs">
              <ul>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Payor
                  </label>
                  <input
                    id="payor"
                    name="payor"
                    type="text"
                    disabled={true}
                    placeholder="Payor"
                    value={argumnts?.payor || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Group
                  </label>
                  <input
                    id="group"
                    name="group"
                    type="text"
                    disabled={true}
                    placeholder="Payor"
                    value={argumnts?.group || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Charge Code
                  </label>
                  <input
                    id="unique"
                    name="unique"
                    type="text"
                    disabled={true}
                    placeholder="Charge Code"
                    value={argumnts?.unique || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Census
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                  <input
                    id="census"
                    name="census"
                    type="number"
                    placeholder="Census"
                    value={census}
                    onChange={(e) => setCensus(e.target.value)}
                    className={` ${census?.length === 0 ? "border-red-400" : ""
                      } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />

                  {census?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify census
                    </p>
                  )}
                </li>
              </ul>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => {
                handleUpdateCensus(census, argumnts?.id);
              }}
              type="button"
              className="mr-0.5 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Create
            </button>

            <button
              onClick={() => {
                setCensusOpenPopUp(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal open={openSummitPopUp} onClose={onCloseSummitModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Edit
          </h3>
          <div className="bg-white mt-4 rounded ">
            <div className="p-2 text-xs">
              <ul>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Payor
                  </label>
                  <input
                    id="payor"
                    name="payor"
                    type="text"
                    disabled={true}
                    placeholder="Payor"
                    value={argumnts?.payor || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Group
                  </label>
                  <input
                    id="group"
                    name="group"
                    type="text"
                    disabled={true}
                    placeholder="Payor"
                    value={argumnts?.group || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Charge Code
                  </label>
                  <input
                    id="unique"
                    name="unique"
                    type="text"
                    disabled={true}
                    placeholder="Charge Code"
                    value={argumnts?.unique || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    RXF Number
                  </label>
                  <input
                    id="rxf_number"
                    name="rxf_number"
                    type="text"
                    disabled={true}
                    placeholder=" RXF Number"
                    value={argumnts?.rxf_number || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Sequence Number
                  </label>
                  <input
                    id="seq_num"
                    name="seq_num"
                    type="text"
                    disabled={true}
                    placeholder="Sequence Number"
                    value={argumnts?.seq_num || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>
                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Doctor name
                  </label>
                  <input
                    id="doctor_name"
                    name="doctor_name"
                    type="text"
                    disabled={true}
                    placeholder="Doctor name"
                    value={argumnts?.doctor_name || ""}
                    className={`border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />
                </li>

                <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                  <label className="text-labelclr font-semibold text-sm tracking-wider">
                    Doctor Group
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                  <input
                    id="doctor_grouping"
                    name="doctor_grouping"
                    type="text"
                    placeholder="Doctor Group"
                    value={doctorGrp}
                    onChange={(e) => setDoctorGrp(e.target.value)}
                    className={` ${doctorGrp?.length === 0 ? "border-red-400" : ""
                      } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                  />

                  {doctorGrp?.length === 0 && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify doctor group
                    </p>
                  )}
                </li>
              </ul>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={() => {
                handleUpdateSummit(doctorGrp, argumnts?.id);
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Update
            </button>

            <button
              onClick={() => {
                setSummitOpenPopUp(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal open={openPopUp} onClose={onCloseRepModal}>
        <AmountModal
          selectedRow={argumnts}
          onCloseModal={onCloseRepModal}
        ></AmountModal>
      </Modal>
      <Modal open={openPCPopUp} onClose={onClosePCModal}>
        <PriceCodeModal
          selectedRow={argumnts}
          onCloseModal={onClosePCModal}
        ></PriceCodeModal>
      </Modal>
      <Modal open={openMARPopUp} onClose={onCloseMARModal}>
        <MARDrugModal
          selectedRow={argumnts}
          onCloseModal={onCloseMARModal}
        ></MARDrugModal>
      </Modal>

      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="border">
          <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
            <div className="w-1/2 text-darkclr font-semibold leading-10 ">
              <span className="text-xl">END OF MONTH</span>
            </div>
          </div>
          <div className="flex w-full p-2 text-xs usersList gridList overflow-x-auto  ">
            <div className="w-1/2 ">
              <div className="w-full">
                <span className="ml-4">
                  <select
                    name="list_month"
                    aria-label="Select Month"
                    value={month}
                    onChange={(e) => {
                      resetButtonState();
                      setMonth(e.target.value);
                    }}
                    className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/3"
                  >
                    <option value="0">Select Month</option>
                    {totalMonthsList()}
                  </select>
                </span>
                <span className="ml-4">
                  <select
                    name="list_year"
                    aria-label="Select Year"
                    value={year}
                    onChange={(e) => {
                      resetButtonState();
                      setYear(e.target.value);
                    }}
                    className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/3 "
                  >
                    {totalYearsList()}
                  </select>
                </span>
                <span className="ml-4">
                  <button
                    disabled={loading}
                    onClick={() => {
                      getScreens(month, year);
                      dispatch1(clearSelectedRow());
                      dispatch1(clearData());
                      setScreen("");
                      setSelectedScreen("");
                      handleAllDownload();
                    }}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    SUBMIT
                  </button>
                </span>
              </div>
              {showScreen && (
                <div className="w-full">
                  <span className="ml-4">
                    <select
                      name="list_screen"
                      onChange={(e) => {
                        setScreen(e.target.value);
                      }}
                      value={screen}
                      aria-label="Select Screen"
                      className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/3"
                    >
                      <option value="0">Select Screen</option>
                      {totalScreenList()}
                    </select>
                  </span>
                  <span className="ml-4">
                    <button
                      disabled={loading}
                      onClick={() => {
                        handleGo(screen, month, year);
                        dispatch1(clearSelectedRow());
                        dispatch1(clearData());
                        handleAllDownload();
                      }}
                      className={
                        loading
                          ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                          : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                      }
                    >
                      GO
                    </button>
                  </span>
                </div>
              )}
            </div>

            <div className="w-1/2 ">
              {showScreen && (<span className="ml-4  float-right">
                <button
                  disabled={loading || !id}
                  title="Everything will be cleared for that month"
                  onClick={() => handleClear()}
                  className={
                    loading || !id
                      ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                      : "text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                  }
                >
                  CLEAR ALL
                </button>
              </span>)}
              {showEOMGenerateDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handlePostDownload({ is_shp: false })}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    GENERATE EOM DATA
                  </button>
                </span>
              )}
              {showEOMProgressDownload && (
                <span className="ml-4">
                  <button
                    disabled={true}
                    className={
                      "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-grey rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    EOM DATA GENERATION IS IN PROGRESS
                  </button>
                </span>
              )}
              {showEOMDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleFileDownload(EOMData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD EOM DATA
                  </button>
                </span>
              )}
              {showEOMDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleDeleteDownload({ is_shp: false, resp: EOMData })}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DELETE EOM FILE
                  </button>
                </span>
              )}

              {showSHPGenerateDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handlePostDownload({ is_shp: true })}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    GENERATE SHP EOM DATA
                  </button>
                </span>
              )}
              {showSHPProgressDownload && (
                <span className="ml-4">
                  <button
                    disabled={true}
                    className={
                      "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-grey rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    SHP EOM DATA GENERATION IS IN PROGRESS
                  </button>
                </span>
              )}
              {showSHPDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleFileDownload(SHPData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD SHP EOM DATA
                  </button>
                </span>
              )}
              {showSHPDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleDeleteDownload({ is_shp: true, resp: SHPData })}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DELETE SHP EOM FILE
                  </button>
                </span>
              )}

              {showMissouriGenerateDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleMissouriAndIndianaDownload()}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    GENERATE MISSOURI AND INDIANA EOM DATA
                  </button>
                </span>
              )}
              {showMissouriProgressDownload && (
                <span className="ml-4">
                  <button
                    disabled={true}
                    className={
                      "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-grey rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    MISSOURI AND INDIANA EOM DATA GENERATION IS IN PROGRESS
                  </button>
                </span>
              )}
              {showMissouriDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleFileDownload(missouriData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD MISSOURI AND INDIANA EOM DATA
                  </button>
                </span>
              )}
              {showMissouriDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleMissouriAndIndianaDeleteDownload(missouriData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DELETE MISSOURI AND INDIANA EOM FILE
                  </button>
                </span>
              )}

              {showKansasGenerateDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleKansasAndIdahoDownload()}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    GENERATE KANSAS AND IDAHO EOM DATA
                  </button>
                </span>
              )}
              {showKansasProgressDownload && (
                <span className="ml-4">
                  <button
                    disabled={true}
                    className={
                      "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-grey rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    KANSAS AND IDAHO EOM DATA GENERATION IS IN PROGRESS
                  </button>
                </span>
              )}
              {showKansasDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleFileDownload(kansasData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD KANSAS AND IDAHO EOM DATA
                  </button>
                </span>
              )}
              {showKansasDownload && (
                <span className="ml-4">
                  <button
                    onClick={() => handleKansasAndIdahoDeleteDownload(kansasData)}
                    disabled={!month}
                    className={
                      loading || !month
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6  mt-2 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DELETE KANSAS AND IDAHO EOM FILE
                  </button>
                </span>
              )}
            </div>
          </div>
        </div>
        <div>
          {selectedScreen === "screen_1" && (
            <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
              {screen1Val === "F" ? (
                <p>
                  YOUR PERVIOUS ATTEMPT TO IMPORT HAS FAILED. WE ARE IMPORTING
                  AGAIN, PLEASE WAIT FOR FEW MINS. IF PROBLEM STILL PERSISTS ,
                  PLEASE CONTACT ADMINISTRATOR.
                </p>
              ) : (
                <p>THE DATA IS IMPORTING, PLEASE WAIT FOR FEW MINS.</p>
              )}
            </div>
          )}
          {selectedScreen === "screen_2" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleDownload()}
                    disabled={loading || gridData?.length === 0}
                    className={
                      loading || gridData?.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={gridData?.length !== 0}
                    onClick={() => handleDone(screen)}
                    className={
                      gridData?.length !== 0 || loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tableProps}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCell1 {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatch}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_3" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => setOpenPopUp(true)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    CREATE
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={loading}
                    onClick={() => handleDone(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsAmount}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellAmount {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchAmount}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_4" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    disabled={loading}
                    onClick={() => handleMARDownload(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD MAR
                  </button>
                </span>

                <span className="mr-3">
                  <button
                    onClick={() => setMAROpenPopUp(true)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    CREATE
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={loading}
                    onClick={() => {
                      setLoading(true);
                      setScreen("screen_5");
                      handleGo("screen_5", month, year);
                      dispatch1(clearSelectedRow());
                      dispatch1(clearData());
                      setLoading(false);
                    }}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    GO TO CENSUS
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsMAR}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellMAR {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchMAR}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_5" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    disabled={loading || gridData.length === 0}
                    onClick={() => handleCensusDownload(screen)}
                    className={
                      loading || gridData.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD CENSUS
                  </button>
                </span>

                <span className="mr-3">
                  <button
                    disabled={gridData.length !== 0}
                    onClick={() => handleDone(screen)}
                    className={
                      gridData.length !== 0 || loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsCensus}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellCensus {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchCensus}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_6" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleDSDownload()}
                    disabled={gridData.length === 0}
                    className={
                      loading || gridData.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={gridData.length !== 0}
                    onClick={() => handleDone(screen)}
                    className={
                      gridData.length !== 0 || loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsDS}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellDS {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchDS}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_7" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleCFDownload()}
                    disabled={gridData.length === 0}
                    className={
                      loading || gridData.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={gridData.length !== 0}
                    onClick={() => handleDone(screen)}
                    className={
                      gridData.length !== 0 || loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsCF}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellCF {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchCF}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_8" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleUCDownload()}
                    disabled={gridData.length === 0}
                    className={
                      loading || gridData.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    disabled={gridData.length !== 0}
                    onClick={() => handleDone(screen)}
                    className={
                      gridData.length !== 0 || loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
                <span className="mr-3">
                  <button
                    onClick={() => handleUnitCostSubmit()}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    SUBMIT
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsUC}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "flag_1":
                              case "flag_2":
                              case "flag_3":
                              case "flag_4":
                              case "flag_5":
                              case "flag_6":
                              case "flag_7":
                              case "flag_8":
                              case "flag_9":
                              case "flag_10":
                                return (
                                  <CustomCellNewCheckbox rowData={props} />
                                );
                              case "other_amt":
                                return <CustomCellOther {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchUnitCost}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedScreen === "screen_9" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    disabled={loading || !gridData?.length}
                    onClick={() => handlePCDownload(screen)}
                    className={
                      loading || !gridData?.length
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>

                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    disabled={loading || gridData?.length}
                    className={
                      loading || gridData?.length
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsPC}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellPC {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchPriceCode}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_10" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    disabled={gridData?.length}
                    className={
                      loading || gridData?.length
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsSummit}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellSummit {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchSummit}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_11" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    disabled={loading}
                    onClick={() => handlePMDownload(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD
                  </button>
                </span>

                <span
                  className="mr-3"
                  onClick={() =>
                    dispatch1(
                      updateEomData({
                        year: year,
                        month: month,
                        screen: screen,
                      })
                    )
                  }
                >
                  <Link
                    to="/create-priceMatch"
                    className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                  >
                    CREATE
                  </Link>
                </span>
                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsPM}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellPM {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchPriceMatch}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_12" && (
            <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
              <p>
                THE FOLLOWING STEPS WILL BE COMPLETED: HEP-C, ST Clair, INS
                Codes.
              </p>
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
            </div>
          )}
          {selectedScreen === "screen_13" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    disabled={loading || !gridData?.length}
                    onClick={() => handleAZDownload(screen)}
                    className={
                      loading || !gridData?.length
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD ERRORS
                  </button>
                </span>

                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    disabled={gridData?.length}
                    className={
                      loading || gridData?.length
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                {gridData?.length !== 0 ? (
                  <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                      {...tablePropsAZ}
                      childComponents={{
                        cellText: {
                          content: (props) => {
                            // eslint-disable-next-line default-case
                            switch (props.column.key) {
                              case "actions":
                                return <CustomCellAZ {...props} />;
                            }
                          },
                        },
                      }}
                      dispatch={dispatchAZ}
                    />
                  </div>
                ) : (
                  <div className="px-16 py-8 text-center	text-dasbrTxtColor font-bold text-2xl">
                    No errors found
                  </div>
                )}
              </div>
            </div>
          )}
          {selectedScreen === "screen_14" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => handleDone(screen)}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DONE
                  </button>
                </span>
              </div>
              <div className="w-full flex justify-center  clearboth mt-4 ">
                <label className="text-labelclr relative top-3 font-semibold text-sm tracking-wider">
                  Amount
                </label>
                <span className="text-xs relative top-3  mr-4 md:text-sm text-hlred ml-1">
                  *
                </span>
                <span className="inline-block w-1/3">
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    placeholder="Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className={` ${error && (!amount || amount === "0")
                      ? "border-red-400"
                      : ""
                      } border focus:outline-none w-full h-9 rounded-md pl-2 font-normal  text-fogotpwsd_login text-sm`}
                  />

                  {error && (!amount || amount === "0") && (
                    <p className="text-xs md:text-sm md:pt-1 text-hlred">
                      You must specify amount
                    </p>
                  )}
                </span>
                <span>
                  <button
                    disabled={loading || disableSubmit}
                    onClick={() => onSHPSubmit()}
                    className={
                      loading || disableSubmit
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 ml-4 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 ml-4  bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    SUBMIT
                  </button>
                </span>
              </div>
            </div>
          )}
          {selectedScreen === "screen_15" && (
            <div className="px-8 py-8">
              <div className="w-full text-center">
                <span className="mr-3">
                  <button
                    onClick={() => onSubmit()}
                    className={
                      loading
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    SUBMIT & DONE
                  </button>
                </span>
              </div>
              <div className="w-full tableHeader  clearboth ">
                <ul className="px-64">
                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Payor
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <select
                      name="payor"
                      aria-label="Select Payor"
                      onChange={(e) => {
                        setParent(e.target.value);
                        setGroup("");
                        setChargeCode("");
                      }}
                      value={parent}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                    >
                      <option value="">Select Payor</option>
                      {parentList
                        ? parentList.map((item, i) => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })
                        : null}
                    </select>
                    {error && parent?.length === 0 && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        You must specify payor
                      </p>
                    )}
                  </li>
                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Group
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>

                    <select
                      name="group"
                      aria-label="Select group"
                      onChange={(e) => {
                        setGroup(e.target.value);
                        setChargeCode("");
                      }}
                      value={group}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                    >
                      <option value="">Select Group</option>
                      {groupList?.length > 0
                        ? groupList.map((item, i) => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })
                        : null}
                    </select>
                    {error && group?.length === 0 && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        You must specify group
                      </p>
                    )}
                  </li>

                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Charge Code
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>
                    <select
                      name="unique"
                      aria-label="Select charge code"
                      onChange={(e) => setChargeCode(e.target.value)}
                      value={chargeCode}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                    >
                      <option value="">Select charge code</option>
                      {chargeCodeList
                        ? chargeCodeList.map((item, i) => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })
                        : null}
                    </select>
                    {error && chargeCode?.length === 0 && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        You must specify charge code
                      </p>
                    )}
                  </li>
                  <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                    <label className="text-labelclr font-semibold text-sm tracking-wider">
                      Amount due
                    </label>
                    <span className="text-xs md:text-sm text-hlred ml-1">
                      *
                    </span>

                    <input
                      id="amt_due"
                      name="amt_due"
                      type="number"
                      placeholder="Amount due"
                      value={amtDue}
                      onChange={(e) => setAmtDue(e.target.value)}
                      className={` ${error && (!amtDue || amtDue === "0")
                        ? "border-red-400"
                        : ""
                        } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                    />

                    {error && (!amtDue || amtDue === "0") && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred">
                        You must specify amount due
                      </p>
                    )}
                  </li>


                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(EOM)
);